/* GARDEN EQUIPMENT — Header (scroll, drawer mobile, accordéon, menu langue) */
(function () {
  "use strict";

  /* Bordure/ombre au scroll (> 12px) */
  var header = document.querySelector("[data-ge-header]");
  /* Sticky porté par le wrapper de section (bloc contenant = <body>, pleine hauteur).
     Fallback pour les navigateurs sans :has() ; sinon le CSS s'en charge déjà. */
  if (header && header.parentElement) {
    var hwrap = header.parentElement;
    var wpos = getComputedStyle(hwrap).position;
    if (wpos !== "sticky" && wpos !== "fixed") {
      hwrap.style.position = "sticky";
      hwrap.style.top = "0";
      hwrap.style.zIndex = "50";
    }
  }
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 12) header.classList.add("is-scrolled");
      else header.classList.remove("is-scrolled");
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* Drawer mobile */
  var drawer = document.querySelector("[data-ge-drawer]");
  /* Portal : sortir le drawer de la section header pour qu'il passe au-dessus
     de tout le contenu (le contenu héro crée un contexte d'empilement z:10 qui
     piégeait le drawer sous lui). Rattaché à <body> = contexte racine. */
  if (drawer && drawer.parentElement !== document.body) {
    document.body.appendChild(drawer);
  }
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-ge-drawer-open]")) {
      e.preventDefault();
      openDrawer();
    } else if (e.target.closest("[data-ge-drawer-close]")) {
      e.preventDefault();
      closeDrawer();
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && drawer && drawer.classList.contains("is-open")) {
      closeDrawer();
    }
  });

  /* Accordéon produits (drawer) */
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-ge-acc-toggle]");
    if (!btn) return;
    var acc = btn.closest("[data-ge-acc]");
    if (!acc) return;
    var open = acc.classList.toggle("is-open");
    btn.setAttribute("aria-expanded", open ? "true" : "false");
  });

  /* Menu langue (clic pour ouvrir, clic dehors pour fermer) */
  var lang = document.querySelector("[data-ge-lang]");
  document.addEventListener("click", function (e) {
    var toggle = e.target.closest("[data-ge-lang-toggle]");
    if (toggle && lang) {
      e.preventDefault();
      var open = lang.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      return;
    }
    if (lang && !e.target.closest("[data-ge-lang]")) {
      lang.classList.remove("is-open");
    }
  });
})();
